import { Component, OnInit } from '@angular/core';
import { ModalController, IonHeader, IonToolbar, IonBackButton, IonTitle, IonButtons, IonButton, IonIcon, IonContent, IonFooter } from '@ionic/angular/standalone';
import { Group, GroupPrivacy } from '../app.types';
import { ApiService } from '../api.service';
import { CommonModule } from '@angular/common';
import { addIcons } from 'ionicons';
import { close } from 'ionicons/icons';

@Component({
    selector: 'app-group-privacy',
    templateUrl: './group-privacy.page.html',
    styleUrls: ['./group-privacy.page.scss'],
    standalone: true,
    imports: [IonFooter, IonContent, IonIcon, IonButton, IonButtons, IonTitle, IonBackButton, IonToolbar, IonHeader, CommonModule]
})
export class GroupPrivacyPage implements OnInit {

  mandatoryRead:boolean
  group:Group
  gprivacy?: GroupPrivacy
  constructor(
    private api: ApiService,
    public modalController: ModalController
  ) {
    addIcons({close});
  }

  async ngOnInit() {
    if(this.group.custom_privacy) {
      const gp = await this.api.getGroupPrivacy(this.group.gid)
      this.gprivacy = gp.gprivacy ? gp.gprivacy : {
        gid: this.group.gid,
        contents: "Privacy del gruppo non presente"
      } as GroupPrivacy
    } 
  }

}
